import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'plain-router-outlet',
    template: '<router-outlet />',
    standalone: true,
    imports: [RouterModule]
})
export class PlainRouterOutletComponent {}
